"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11h9v-1H6v1zm9-4h-1.5c-.98 0-1.94.82-2.5 2h1c.46-.6.69-1 1.5-1H15c1.38 0 2 1.12 2 2.5s-.62 2.5-2 2.5h-1.5c-.81 0-1.04-.4-1.5-1h-1c.56 1.18 1.55 2 2.5 2H15c1.93 0 3-1.57 3-3.5S16.93 7 15 7zm-7.5 6H6c-1.38 0-2-1.12-2-2.5S4.62 8 6 8h1.5c.81 0 1.04.4 1.5 1h1c-.56-1.18-1.47-2-2.5-2H6c-1.93 0-3 1.57-3 3.5S4.07 14 6 14h1.5c1.05 0 1.94-.82 2.5-2H9c-.46.6-.69 1-1.5 1z",
    fillRule: "evenodd"
  }));
};